import script from "./ProjectsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsPage.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsPage.vue?vue&type=style&index=0&id=6fdb58e1&lang=css"

const __exports__ = script;

export default __exports__